"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFieldsNotEmpty = exports.validateDescriptionLength = exports.validateNameLength = exports.validateNameNotEmpty = exports.success = void 0;
const ValidationUtils = require("../../../utils/validation");
exports.success = ValidationUtils.successValidation;
const REPORT_NAME_MAX_LENGTH = 255;
const REPORT_DESCRIPTION_MAX_LENGTH = 65535;
const validateNameNotEmpty = (payload) => ValidationUtils.ap(ValidationUtils.isNotEmpty('name')(payload));
exports.validateNameNotEmpty = validateNameNotEmpty;
const validateNameLength = (payload) => ValidationUtils.ap(ValidationUtils.hasInvalidLength('name', null, REPORT_NAME_MAX_LENGTH)(payload.name));
exports.validateNameLength = validateNameLength;
const validateDescriptionLength = (payload) => ValidationUtils.ap(ValidationUtils.hasInvalidLength('description', null, REPORT_DESCRIPTION_MAX_LENGTH)(payload.description));
exports.validateDescriptionLength = validateDescriptionLength;
const validateFieldsNotEmpty = (payload) => ValidationUtils.ap(ValidationUtils.isNotEmptyList('fields')(payload.fields));
exports.validateFieldsNotEmpty = validateFieldsNotEmpty;
//# sourceMappingURL=validation.js.map